"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinateUtil = void 0;
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const valveInfo_1 = require("../waterTestingValve/valveInfo");
class CoordinateUtil {
    constructor(center, mainDirectionAngle) {
        this._center = center;
        this._mainDirectionAngle = mainDirectionAngle;
        this._geometryFactory = new GeometryFactory_js_1.default();
    }
    transformLineSegmentToLocal(source) {
        let p0_vec = new Vector2D_js_1.default(source.p0);
        let p1_vec = new Vector2D_js_1.default(source.p1);
        let center_vec = new Vector2D_js_1.default(this._center);
        p0_vec = p0_vec.subtract(center_vec);
        p0_vec = p0_vec.rotate(-1 * this._mainDirectionAngle);
        p1_vec = p1_vec.subtract(center_vec);
        p1_vec = p1_vec.rotate(-1 * this._mainDirectionAngle);
        return new LineSegment_js_1.default(p0_vec.getX(), p0_vec.getY(), p1_vec.getX(), p1_vec.getY());
    }
    transformLineSegmentArrayToLocal(source) {
        let result = new Array();
        for (let seg of source) {
            result.push(this.transformLineSegmentToLocal(seg));
        }
        return result;
    }
    transformPointToLocal(point) {
        let vec = new Vector2D_js_1.default(point);
        let center_vec = new Vector2D_js_1.default(this._center);
        vec = vec.subtract(center_vec);
        vec = vec.rotate(-1 * this._mainDirectionAngle);
        return new Coordinate_js_1.default(vec.getX(), vec.getY());
    }
    transformLinearRingToLocal(ring) {
        let points = ring.getCoordinates();
        let points_local = [];
        for (let point of points) {
            points_local.push(this.transformPointToLocal(point));
        }
        return this._geometryFactory.createLinearRing(points_local);
    }
    transformPolygonToLocal(polygon) {
        const shell = polygon.getExteriorRing();
        let shell_local = this.transformLinearRingToLocal(shell);
        let holes_local = new Array();
        for (let i = 0; i < polygon.getNumInteriorRing(); i++) {
            const hole = polygon.getInteriorRingN(i);
            holes_local.push(this.transformLinearRingToLocal(hole));
        }
        return this._geometryFactory.createPolygon(shell_local, holes_local);
    }
    transformLineSegmentToWorld(source) {
        let p0_vec = new Vector2D_js_1.default(source.p0);
        let p1_vec = new Vector2D_js_1.default(source.p1);
        let center_vec = new Vector2D_js_1.default(this._center);
        p0_vec = p0_vec.rotate(this._mainDirectionAngle);
        p0_vec = p0_vec.add(center_vec);
        p1_vec = p1_vec.rotate(this._mainDirectionAngle);
        p1_vec = p1_vec.add(center_vec);
        return new LineSegment_js_1.default(p0_vec.getX(), p0_vec.getY(), p1_vec.getX(), p1_vec.getY());
    }
    transformPointToWorld(point) {
        let vec = new Vector2D_js_1.default(point.x, point.y);
        let center_vec = new Vector2D_js_1.default(this._center.x, this._center.y);
        vec = vec.rotate(this._mainDirectionAngle);
        vec = vec.add(center_vec);
        if (point instanceof ltpoint_1.LTPoint) {
            return new ltpoint_1.LTPoint(vec.getX(), vec.getY());
        }
        else {
            return new Coordinate_js_1.default(vec.getX(), vec.getY());
        }
    }
    transformValveToWorld(valve_local) {
        return new valveInfo_1.ValveInfo(this.transformPointToWorld(valve_local._position), valve_local._angle - this._mainDirectionAngle);
    }
}
exports.CoordinateUtil = CoordinateUtil;
